<template>
  <div class="card" :class="{ active: selected }">
    <h2 class="card__title">{{ title }}</h2>
    <p v-if="pricing" class="card__price" :class="{ active: selected }">
      ${{ price.monthly }}
    </p>
    <p v-else class="card__price" :class="{ active: selected }">
      ${{ price.anually }}
    </p>
    <div class="card__features">
      <p class="card__feature">{{ storage }} Storage</p>

      <p class="card__feature">{{ users }} Users Allowed</p>

      <p class="card__feature">Send Up To {{ transfer }}</p>
    </div>
    <button @click="select" class="card__btn" :class="{ active: selected }">
      learn more
    </button>
  </div>
</template>

<script>
export default {
  name: "PlanCard",

  computed: {
    selected() {
      return this.title === this.currentPlan;
    },
  },
  methods: {
    select() {
      this.$emit("select", this.title);
    },
  },
  props: [
    "title",
    "price",
    "storage",
    "users",
    "transfer",
    "pricing",
    "currentPlan",
  ],
};
</script>


